import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import type { User } from "../../types/User";
import { isVelvetUiActive } from "../../utils/brandLogo";

/**
 * Applies Velvet brand CSS only on /dashboard routes for JU users.
 * Static pages keep the normal ToothSketch colour scheme.
 */
const BrandThemeSync = () => {
  const user = useAppSelector((state) => state.auth.user as User | null);
  const { pathname } = useLocation();

  useEffect(() => {
    const root = document.documentElement;
    if (isVelvetUiActive(user, pathname)) {
      root.setAttribute("data-brand", "velvet");
    } else {
      root.removeAttribute("data-brand");
    }
    return () => {
      root.removeAttribute("data-brand");
    };
  }, [user?.token, pathname]);

  return null;
};

export default BrandThemeSync;
